import React from 'react';
import { Card, CardContent, Grid, TextField, CardActions, Button, CardHeader } from '@material-ui/core';
import { Link } from 'react-router-dom';
import Empty from 'validator/lib/isEmpty';
import { withSnackbar } from 'notistack';
import LazyBox from '../../../web/components/LazyBox';

//services
import BannerAPI from '../../../services/api/Banner';

class NovoBanner extends React.Component {
	state = {
		loading:false,
		loading_page: true,

		descricao: '',
		arquivo:'',
		link:'',

		isDescricao:false,
		isArquivo:false,
		isLink: false,

		data_arquivo:null,
	}

	Submit = (event) => {
		const { enqueueSnackbar, history } = this.props;
		const { descricao, arquivo, link } = this.state;
		const { id } = this.props.match.params;
		event.preventDefault();
		if (Empty(descricao)) {
			this.setState({ isDescricao: true }, () => enqueueSnackbar('Preencha o campo de descrição'));
			return;
		}
		if (Empty(link)) {
			this.setState({ isLink: true }, () => enqueueSnackbar('Preencha o campo de url'));
			return;
		}
		this.setState({ loading:true }, () => enqueueSnackbar("Aguarde efetuando o cadastro.."));
		let forms = {
			descricao: descricao,
			link: link,
			arquivo
		}
		BannerAPI.editar(forms,id)
				.then(res => {
					res.json().then(res => {
						if (res.msg) {
							this.setState({ loading: false }, () => enqueueSnackbar(res.msg));
							return;
						}
						enqueueSnackbar('Alteração efetuada com sucesso');
						history.push('/painel/banners');
					})
				}).catch(() => this.setState({ loading: false }, () => enqueueSnackbar('Não foi possivel efetuar o cadastro, tente novamente mais tarde.')))

		return;
	}

	RefreshBanner = () => {
		const { id } = this.props.match.params;
		const { enqueueSnackbar } = this.props;
		BannerAPI.get(id)
				 .then(res => {
						res.json().then(res => {
							if (res.msg) {
								this.setState({ loading: false }, () => enqueueSnackbar(res.msg));
								return;
							}
							this.setState({
								descricao: res.descricao,
								link: res.link,
								data_arquivo: res.url,
								loading_page:false,
							});
						})
				 }).catch(() => this.setState({ loading: false }, () => enqueueSnackbar('Não foi possivel efetuar o cadastro, tente novamente mais tarde.')))
	}

	componentDidMount(){
		this.RefreshBanner();
	}

    render() {
		const { data_arquivo, descricao, loading, link, loading_page } = this.state;
        return (
				<div className="app_control__content_padding" >
					<LazyBox loading={loading_page} height="80vh" >
						<Grid container spacing={16} >
							<Grid item xs={12} >
								<form onSubmit={this.Submit} >
									<Card elevation={0} >
										<CardHeader title="Alterar" />
										<CardContent>
											<Grid container spacing={16} >
												<Grid item xs={12} >
													<TextField
														label="Descrição"
														value={descricao}
														onChange={e => this.setState({ descricao: e.target.value })}
														margin="normal"
														variant="outlined"
														fullWidth
													/>
												</Grid>
												<Grid item xs={12} >
													<TextField
														label="URL ( Link do evento ou promoção )"
														value={link}
														onChange={e => this.setState({ link: e.target.value })}
														margin="normal"
														variant="outlined"
														fullWidth
													/>
												</Grid>
												<Grid item xs={12} >
													<TextField
														label="Imagem"
														type="file"
														onChange={e => this.setState({ arquivo: e.target.files[0],
																					data_arquivo: URL.createObjectURL(e.target.files[0]) })}
														margin="normal"
														variant="outlined"
														helperText="( Resolução minima indicada: 1400x700, Tamanho máximo 3MB )"
														fullWidth
														InputLabelProps={{
															shrink:true
														}}
													/>
												</Grid>
												{data_arquivo && <Grid item xs={12} >
													<img width="100%" style={{marginBottom:-8}} src={data_arquivo} alt="Demo" />
												</Grid>}
											</Grid>
										</CardContent>
										<CardActions>
											<Button type="submit" variant="outlined" disabled={loading} color="primary" >Salvar</Button>
											<Button variant="outlined" color="inherit" component={Link} to="../banners" >cancelar</Button>
										</CardActions>
									</Card>
								</form>
							</Grid>
						</Grid>
					</LazyBox>
				</div>
        );
    }
}

export default withSnackbar(NovoBanner);



// WEBPACK FOOTER //
// ./src/painel/pages/banners/editar.js